import { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import styles from './EventFilterListManager.module.css'
import { useNavigate, useLocation } from 'react-router-dom'
// ------ Services ------ //
import * as clientEventService from '../../../services/clientEventService'

const EventFilterListManager = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const passedState = location.state
    // useLocation & useNavigate --- Client state from previous page
    const [clientEventInfo, setClientEventInfo] = useState({})
    const clientEventInfoRef = useRef(null);
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current =passedData
        }
       
    }
    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])

    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }

    }, [])
    return (
        <div id={styles.eventConfigurePage}>
            <h1>Client Event Fields Filter List Management</h1><br />
            <h2>Control event badge filtering setup.</h2><br />
            <div id={styles.eventConfigureContainer}>
                <Link to={`/EventSetting/EventFilterList`} state={clientEventInfo} className={styles.eventLinks} title="Manage event registrant property filtering.">
                    <h3>Event Filtering</h3>
                </Link>
                <Link to={`/EventSetting/GuestEventFilterList`} state={clientEventInfo} className={styles.eventLinks} title="Manage event guest property filtering.">
                    <h3>Event Guest Filtering</h3>
                </Link>
            </div>

            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
        </div>
    );
}

export default EventFilterListManager;